export default __webpack_public_path__ + "static/media/roadmap-d-5.c60e3a0f.png";